import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-context-menu-blank'
})
export default class EdContextMenuBlank extends Vue {

  @Prop() readonly options: any;

  public comp: any;
  public params: any = null;

  created() {
    this.comp = this.options.comp;
    this.params = this.options.params;
  }

}